import React, {
  useCallback,
  useState,
  useMemo,
  useEffect,
  useRef,
} from "react";
import FeedbackReceive from "../../components/CommonMail/FeedbackReceive";
import ContentFeedback from "../../components/CommonMail/ContentFeedback";
import { Box } from "@mui/material";
import Styles from "./Feedback.module.scss";
import {
  getTicketChat,
  updateTicket,
  publicHolidays,
} from "../../services/ticket.service";
import { ROLES } from "../../constant/constant";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import { setUnreadCount } from "../../redux/Reducer/notificationReducer";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useTicketData } from "../../context/TicketContext";
import ExtendExpiryDialog from "./ExtendExpiryDialog";
import { calculateTicketRemainingTime } from "../../utils/timerUtils";
// import {
//   getServiceRequestByDept,
//   updateServiceRequest,
// } from "../../services/serviceRequest.service";
// import { toastSuccess } from "../../utils/toaster";
// import ConfirmBox from "../../sharedComponents/ConfirmBox/ConfirmBox";
// import AddFormforFeedback from "../../sharedComponents/CommonFeedback/AddFormforFeedbackManage";
// import { errorMessage } from "../../utils/errorHandleFunctions";

// Classify a ticket's SLA timer exactly the way the header counts and the
// Timer chips do (shared calculateTicketRemainingTime), then keep/drop it:
//   timerStatus === 1 -> "Within time" (remaining >= 0)
//   timerStatus === 2 -> "Out of time" (remaining < 0)
//   anything else      -> no timer filter (return as-is)
// Running this on the client (instead of the server) is what guarantees the
// list and the header SLA counts always agree — same data, same function,
// same holidays/timezone inputs.
// Effective send status of a ticket, matching the badge / extra-timer logic in
// FeedbackReceive: normally the ticket's own sendStatus ("2" Initial, "5" Need
// info, "4" Final), but when the guest has replied AFTER a Final/Need-info
// message (last non-auto message has no sendStatus) it becomes "6" (Response).
// "Response" only exists as this derived state — the backend can't filter it,
// so the Send Status filter runs on the client.
const getEffectiveSendStatus = (ticket) => {
  const msgs = (ticket?.replyMessages || []).filter((m) => !m?.isAutoGenerated);
  const last = msgs[msgs.length - 1];
  let i = msgs.length - 2;
  while (i >= 0 && !["2", "3", "4", "5"].includes(msgs[i]?.sendStatus)) i--;
  const prev = msgs[i];
  if (!last?.sendStatus && ["4", "5"].includes(prev?.sendStatus)) return "6";
  if (last?.sendStatus) return String(last.sendStatus);
  return ticket?.sendStatus != null ? String(ticket.sendStatus) : null;
};

const filterGroupsBySendStatus = (groups, sendStatus) => {
  // null / 1 mean "All" (1 is the legacy value of the All option)
  if (sendStatus == null || Number(sendStatus) === 1) return groups;
  const wanted = String(sendStatus);
  return (groups || [])
    .map((group) => ({
      ...group,
      dataInfo: (group.dataInfo || []).filter(
        (ticket) => getEffectiveSendStatus(ticket) === wanted
      ),
    }))
    .filter((group) => (group.dataInfo?.length || 0) > 0);
};

const filterGroupsByTimerRange = (groups, timerStatus, holidays) => {
  if (Number(timerStatus) !== 1 && Number(timerStatus) !== 2) return groups;
  return (groups || [])
    .map((group) => ({
      ...group,
      dataInfo: (group.dataInfo || []).filter((ticket) => {
        const remaining = calculateTicketRemainingTime(
          ticket.createdAt,
          Number(ticket.expiry) || 2, // completion window in days
          9, // DURATION (working hours per day)
          holidays,
          ticket.ticketStatus,
          ticket.tempEndTime || null,
          18, // WORK_END_HOUR
          0, // minutes
          0 // seconds
        );
        return Number(timerStatus) === 1 ? remaining >= 0 : remaining < 0;
      }),
    }))
    .filter((group) => (group.dataInfo?.length || 0) > 0);
};

const FeedBack = () => {
  const dispatch = useDispatch();
  const { setTicketData, setPublicHolidays } = useTicketData();
  const [selectedData, setSelectedData] = useState({});
  const location = useLocation();
  const locationData = location.state;
  const [openConfirmBox, setOpenConfirmBox] = useState(false);
  const [openExpiryBox, setOpenExpiryBox] = useState(false);
  const [sendOpenLoader, setSendOpenLoader] = useState(false);
  const [data, setData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Open");
  const [selectedTimerStatus, setSelectedTimerStatus] = useState(null);
  const [selectedSendStatus, setSelectedSendStatus] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Unread");
  const [openLoader, setOpenLoader] = useState(false);
  const [userId, setUserId] = useState(null);
  const [departmentId, setDepartmentId] = useState(null); // Added departmentId state
  const [supportTicket, setSupportTicket] = useState(false); // Added departmentId state
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedFormData, setSelectedFormData] = useState({});
  const [formType, setFormTpe] = useState();
  const [filterKey, setFilterKey] = useState(false);
  const [publicHoliday, setPublicHoliday] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    startDate: null,
    endDate: null,
  });

  const ticketStatus = [
    { value: "0", label: "Open" },
    { value: "1", label: "Closed" },
  ];

  const [definedRole, setDefinedRole] = useState(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setDefinedRole(storedRole);
    }
  }, []);

  const getInitialStatus = useCallback(() => {
    const foundStatus = ticketStatus.find(
      (status) => status.value === selectedData?.ticketStatus
    );
    return foundStatus ? foundStatus.label : null;
  }, [selectedData]);

  const [status, setStatus] = useState(getInitialStatus);
  const currentUserId = localStorage.getItem("userId");
  const getTicketUserData = async (queryParams = {}) => {
    setOpenLoader(true);
    try {
      const userId1 = localStorage.getItem("userId");
      let params = { ...queryParams };
      // if (definedRole === ROLES[1] || definedRole === ROLES[2]) {
      if (definedRole == ROLES[2] || definedRole == ROLES[3]) {
        params = {
          isAssigned: true,
          assignedTo: userId ? userId : userId1, // Use userId from state, fallback to localStorage
          assignedDepartmentId: departmentId ? departmentId : null, // Added departmentId
          startDate:
            selectedDate?.startDate ||
            dayjs().startOf("month").format("YYYY-MM-DD"),
          endDate:
            selectedDate?.endDate ||
            dayjs().endOf("month").format("YYYY-MM-DD"),
          isRead: selectedTab === "Unread" ? false : null,
          supportTicket: supportTicket,
          ...queryParams,
        };
      } else {
        params = {
          sort: "-lastMessageAt",
          isAssigned: true,
          assignedTo: userId ? userId : null,
          assignedDepartmentId: departmentId ? departmentId : null, // Added departmentId
          startDate:
            selectedDate?.startDate ||
            dayjs().startOf("month").format("YYYY-MM-DD"),
          endDate:
            selectedDate?.endDate ||
            dayjs().endOf("month").format("YYYY-MM-DD"),
          isRead: selectedTab === "Unread" ? false : null,
          supportTicket: supportTicket,
          ...queryParams,
        };
      }
      const res = await getTicketChat(params);
      const modifiedData =
        res?.data.map((e) => {
          // Sort tickets by remaining time ascending (overdue/small remaining time first)
          if (e.dataInfo && Array.isArray(e.dataInfo)) {
            e.dataInfo.sort((a, b) => {
              const remainingA = calculateTicketRemainingTime(
                a.createdAt,
                Number(a.expiry) || 2, 9, publicHoliday, a.ticketStatus, a.tempEndTime, 18, 0, 0
              );
              const remainingB = calculateTicketRemainingTime(
                b.createdAt,
                Number(b.expiry) || 2, 9, publicHoliday, b.ticketStatus, b.tempEndTime, 18, 0, 0
              );
              return remainingA - remainingB;
            });
          }
          return { ...e };
        }) || [];
      // Apply the Within/Out-of-time filter on the client so the list and the
      // header SLA counts are derived from the exact same calculation.
      // The Send Status filter also runs on the client: the backend ignores
      // sendStatus, and "Response" is a derived state it can't express.
      const finalData = filterGroupsBySendStatus(
        filterGroupsByTimerRange(
          modifiedData,
          selectedTimerStatus,
          publicHoliday
        ),
        selectedSendStatus
      );
      setData(finalData);
      setTicketData(finalData);
      setOpenLoader(false);
    } catch (error) {
      if (error?.status == 429) {
        callAgainFunct();
      }
      console.log(error);
    }
  };

  const callAgainFunct = async () => {
    await getTicketUserData();
  };
  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    if (data) {
      const totalUnread = data.reduce((acc, group) => {
        return acc + (group.dataInfo?.reduce((groupAcc, ticket) => {
          const isRelevant = definedRole === ROLES[0] ||
            String(group.assignedToInfo?._id) === String(currentUserId) ||
            String(ticket.createdByInfo?._id) === String(currentUserId);
          return groupAcc + (ticket.isRead === false && isRelevant ? (ticket.unReadCount || 0) : 0);
        }, 0) || 0);
      }, 0);
      dispatch(setUnreadCount(totalUnread));
    }
  }, [data, dispatch, currentUserId, definedRole]);

  const getPublicHolidays = async () => {
    try {
      const res = await publicHolidays();
      const modData = res?.data?.map((e) => e?.day ? dayjs(e?.day).format("YYYY-MM-DD") : false).filter(Boolean);
      setPublicHoliday(modData);
      // Share the same holidays with the Header so its SLA counts match the
      // Timer chips and the timer filter (it previously received an empty []).
      setPublicHolidays(modData);
    } catch (error) {
      console.log(error);
    }
  };

  const updateFunction = useCallback(async () => {
    setSendOpenLoader(true);
    const data = {
      ticketStatus: status?.value,
    };
    try {
      const res = await updateTicket(selectedData._id, data);
      const header = {
        ticketStatus:
          selectedStatus === "Open"
            ? "0"
            : selectedStatus === "Closed"
              ? "1"
              : null,
      };
      await getTicketUserData(header);
      setOpenConfirmBox(false);
      setSendOpenLoader(false);
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "error" }));
      setOpenConfirmBox(false);
      setStatus(getInitialStatus);
    }
  }, [selectedData, status]);

  // Deliberately NOT memoized: a useCallback with a partial dependency list
  // captured a stale getTicketUserData, so searching after changing the
  // Department / Assignee / date-range filters refetched with the OLD filter
  // values. Recreating the handler each render keeps every filter fresh; the
  // debounce timer lives in a ref so it survives re-renders.
  const onSearchChange = (e) => {
    const searchQuery = e.target.value || "";

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(async () => {
      const headers = {
        // Timer and Send Status filters run on the client (see
        // filterGroupsByTimerRange / filterGroupsBySendStatus).
        search: searchQuery,
        ticketStatus:
          selectedStatus === "Open"
            ? "0"
            : selectedStatus === "Closed"
              ? "1"
              : null,
      };

      await getTicketUserData(headers);
    }, 1500);
  };

  useEffect(() => {
    if (definedRole) {
      const headers = {
        isAssigned: true,
        ticketStatus:
          selectedStatus === "Open"
            ? "0"
            : selectedStatus === "Closed"
              ? "1"
              : null,
        // Timer (Within / Out of time) and Send Status filters are applied on
        // the client — see filterGroupsByTimerRange / filterGroupsBySendStatus.
        // The backend ignores sendStatus/timerType, and its timerStatus param
        // means something else entirely (tempEndTime set or not), so sending
        // the UI values here was at best a no-op and at worst wrong.
        isRead: selectedTab === "Unread" ? false : null,
      };
      getTicketUserData(headers);
    }
  }, [filterKey, definedRole, selectedTab, publicHoliday]);

  useEffect(() => {
    getPublicHolidays();
  }, []);

  const formData = useMemo(
    () => ({
      title: "Facility Management",
      departmentId: 3,
    }),
    []
  );
  return (
    <div className={Styles.container} style={{ padding: 0 }}>
      <Box className={Styles.leftContainer}>
        <FeedbackReceive
          data={data}
          setData={setData}
          setSelectedData={setSelectedData}
          locationData={locationData}
          onSearchChange={onSearchChange}
          setSelectedStatus={setSelectedStatus}
          setSelectedTimerStatus={setSelectedTimerStatus}
          setSelectedSendStatus={setSelectedSendStatus}
          setSelectedTab={setSelectedTab}
          selectedStatus={selectedStatus}
          selectedTimerStatus={selectedTimerStatus}
          selectedSendStatus={selectedSendStatus}
          setUserId={setUserId}
          setDepartmentId={setDepartmentId} // Passed setDepartmentId prop
          setOpenAddForm={setOpenDrawer}
          openLoader={openLoader}
          setSelectedFormData={setSelectedFormData}
          setSupportTicket={setSupportTicket}
          supportTicket={supportTicket}
          setFormTpe={setFormTpe}
          getData={getTicketUserData}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          filterKey={filterKey}
          setFilterKey={setFilterKey}
          publicHolidays={publicHoliday}
        />
      </Box>

      <Box className={Styles.rightContainer}>
        <ContentFeedback
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          setOpenConfirmBox={setOpenConfirmBox}
          setOpenExpiryBox={setOpenExpiryBox}
          status={status}
          setStatus={setStatus}
          getInitialStatus={getInitialStatus}
          getTicketUserData={getTicketUserData}
        />
      </Box>
      <ConfirmBox
        open={openConfirmBox}
        title="Update"
        content="Are you sure want to Update this record ?"
        confirmButton="Update"
        setOpenConfirmBox={setOpenConfirmBox}
        Function={updateFunction}
        sendOpenLoader={sendOpenLoader}
      />
      {openExpiryBox ? (
        <ExtendExpiryDialog
          ticket={selectedData}
          holidays={publicHoliday}
          handleClose={() => setOpenExpiryBox(false)}
          onExtended={(expiry) => {
            setSelectedData((prev) => ({ ...prev, expiry }));
            getTicketUserData({
              ticketStatus:
                selectedStatus === "Open"
                  ? "0"
                  : selectedStatus === "Closed"
                    ? "1"
                    : null,
            });
          }}
        />
      ) : null}
      {/* {openDrawer ? (
        <Dialog
          open={openDrawer}
          PaperProps={{
            style: {
              width: "100%",
              height: "fit-content",
            },
          }}
          fullWidth
          maxWidth="md"
        >
          <AddFormforFeedback
            setOpenDrawer={setOpenDrawer}
            selectedData={{ ...formData, ...selectedFormData }}
            getFormData={getServiceRequestByDeptDataFilter}
            formType={formType}
          />
        </Dialog>
      ) : null} */}
    </div>
  );
};

export default FeedBack;
